// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nq7E","label":"styles_label__1EfBE"};